module.exports = __webpack_public_path__ + "img/scanned-document-erased.129ce2f4.webp";